import http from '@/utils/http'
import { PATH_SL, PATH_USER_CENTER } from './consts'
import { PlayerReq } from './types/player'

export const getCurPlayer = () => {
  return http.get(`${PATH_USER_CENTER}/v2/users/me`)
}

export const getPlayers = () => {
  return http.get(`${PATH_USER_CENTER}/v2/players`)
}

export const getPlayerById = (playerId: string) => {
  return http.get(`${PATH_USER_CENTER}/v2/players/${playerId}`)
}

export const addPlayer = (data: PlayerReq) => {
  return http.post(`${PATH_USER_CENTER}/v2/players`, data)
}

export const updatePlayer = ({ playerId, ...data }: PlayerReq) => {
  return http.put(`${PATH_USER_CENTER}/v2/players/${playerId}`, data)
}

export const deletePlayer = (playerId: string) => {
  return http.delete(`${PATH_USER_CENTER}/v2/players/${playerId}`)
}

export const checkFace = (faceId: string) => {
  return http.post(`${PATH_SL}/v2/facade/checkimage`, {
    image_id: faceId,
  })
}
